import { useSelector } from 'react-redux';
import { controlDevicePageItemsSelector } from '~/features/devices/selectors/controlDeviceSelectors';

export const useLimitedDeviceSerials = (maxDevices: number): string[] => {
    const controlDevices = useSelector(controlDevicePageItemsSelector);

    return controlDevices
        .slice(0, maxDevices)
        .map(device => device.originalSerialNumber);
};
